<template lang="pug">
  .activity-success
    .header
      img(src="../../../public/images/member/activity-success-header.png")
    .page-module.flow
      img(src="../../../public/images/member/activity-success-flow.png")
    .page-module.pay
      .title 支付方式
      .pay-item
        .pay-name
          img(src="../../../public/images/member/wx-pay.jpg")
          span 微信支付
        .pay-select
          input(type="radio", checked)
    .pay-bottom
      .tip 领不到话费，全额退款
      .price
        span.label 会员费：
        span.price-val ¥9.9
        del ¥29.8
      .submit-button
        el-button(@click="toPay") 确认支付
</template>

<script>
export default {
  data() {
    return {
      channel: 'TUIA',
      form: {
        mobile: '',
        verifyCode: '',
        goodsCode: 'WXMIXPAY210105001'
      },
      channelOrderNo: ''
    }
  },
  mounted() {
    this.form.mobile = this.$route.query.mobile
    this.form.verifyCode = this.$route.query.verifyCode
    this.channelOrderNo = this.$route.query.oid
    if ((!this.form.mobile || !this.form.verifyCode) && window.localStorage) {
      let _orderCache = JSON.parse(localStorage.getItem('language-member-order'));
      this.form.mobile = _orderCache.mobile
      this.form.verifyCode = _orderCache.verifyCode
      this.channelOrderNo = _orderCache.oid
    }
    if (window._czc) {
      window._czc.push(['_trackEvent', 'Language会员', 'H5确认订单露出', 'Language会员', 1, '成功'])
    }
  },
  methods: {
    toPay() {
      let _formData = {
        mobile: this.form.mobile,
        goodsCode: this.form.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel,
        tradeType: 'MWEB',
        channelOrderNo: this.channelOrderNo
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在验证并创建订单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (window._czc) {
        window._czc.push(['_trackEvent', 'Language会员', 'H5触发订单支付', 'Language会员', 1, '成功'])
      }
      this.$service.OrderService
        .createActPayOrder(_formData)
        .then(res => {
          if (res.data.success) {
            if (window._czc) {
              window._czc.push(['_trackEvent', 'Language会员', 'H5订单支付跳转', 'Language会员', 1, '成功'])
            }
            this.$message({
              type: 'success',
              message: '订单创建完成，正在前往支付...'
            })
            
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }

            let _redirect_url = 'https://' + location.host + '/normal.html#/language/validpay?mobile=' + this.form.mobile + '&req_no=' + res.data.sub_data.req_no
            let _to_pay_url = res.data.sub_data.pay_url + '&redirect_url=' + encodeURIComponent(_redirect_url)
            localStorage.setItem('topayurl', _to_pay_url)
            localStorage.setItem('req_no', res.data.sub_data.req_no)
            localStorage.setItem('mobile', this.form.mobile)
            location.href = _to_pay_url
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.activity-success{
  background-color: #f3f3f3;
  min-height: 50rem;
  img{
    width: 100%;
  }
}
.info{
  font-size: 1.1rem;
  text-align: center;
  padding-top: 3rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  padding: 0 1rem;
  .bl{
    width: 100%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
.point{
  margin: .5rem 0;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
.page-module{
  width: 92%;
  margin: 0 auto;
  border-radius: 4px;
}
.pay-bottom{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background-color: #fff;
  >div{
    flex: 1;
    height: 3.4rem;
    line-height: 3.4rem;
    &.price{
      font-size: 1rem;
      .label{
        margin-left: .5rem;
      }
      .price-val{
        font-size: 1.4rem;
        color: #f04346;
      }
      del{
        font-size: .8rem;
        color: #a3a3a3;
      }
    }
    &.submit-button{
      text-align: right;
      button{
        border: 0;
        background-color: #f04346;
        color: #fff;
        font-size: 1.2rem;
        width: 100%;
        height: 3.4rem;
        border-radius: 0;
      }
    }
  }
  .tip{
    background: linear-gradient(to bottom,#ff632a,#ff3143);
    color: #fff;
    font-size: .8rem;
    position: absolute;
    top: -1.6rem;
    left: 3rem;
    border-radius: .3rem;
    height: 1rem;
    line-height: 1rem;
    padding: .2rem .4rem;
    &:after{
      content: '';
      position: absolute;
      left: 1rem;
      bottom: 0;
      width: 0;
      height: 0;
      border: .3rem solid transparent;
      border-top: .6rem solid #ff3143;
      transform: translateY(100%) skew(-30deg);
    }
  }
}
.pay{
  background-color: #fff;
  padding: .3rem 0;
  .title{
    padding: .3rem .5rem;
    font-size: 1rem;
    color: #525252;
  }
  .pay-item{
    display: flex;
    padding: .3rem;
    >div{
      flex: 1;
    }
    .pay-name{
      font-size: 1rem;
      img{
        width: 1.3rem;
        height: 1.3rem;
        vertical-align: top;
        margin: 0 .3rem;
      }
    }
    .pay-select{
      text-align: right;
      input{
        margin-right: 1rem;
      }
    }
  }
}
</style>